export enum FlowStep {
    MATERIALS,
    GEOMETRY,
    LOADCASES,
    GOALS,
    MANUFACTURING,
    RESULTS
}

export const FlowStepName = [
    "Materials",
    "Geometry",
    "Loadcases",
    "Goals",
    "Manufacturing",
    "Results"
];

export enum FlowStepInner {
    NONE,
    LOAD_TYPE,
    BOUNDARY_CONDITIONS,
    LOADS,
    ACCELERATION_SETTINGS,
    EDIT_LOAD,
    ADD_GROUP,
    EDIT_GROUP,
    SELECT_FACES,
    BASE_PARTS
}

export const FlowStepInnerName = [
    "None",
    "Load Type",
    "Boundary Conditions",
    "Loads",
    "Acceleration Settings",
    "Edit Load",
    "Add Group",
    "Edit Group",
    "Select Faces",
    "Base"
]

export enum SideMenuView {
    MODELS,
    FLOW,
    WIZARD,
    UCS,
    SETTINGS,
    SOFTJAWS,
    RIBS,
    BOSSES,
    CAD_EDITOR,
    PROJECT_SETTINGS,
    RESULTS
}

export enum LoadCasesFlowStep {
    LOAD_TYPE,
    BOUNDARY_CONDITIONS,
    LOADS,
    ACCELERATION_SETTINGS,
    EDIT_LOAD,
    ADD_GROUP,
    EDIT_GROUP,
    SELECT_FACES,
    BASE_PARTS,
    /** Manual preserve-face selection. Engine selector enters face-pick
     *  mode but suppresses hover/unhover repaints — only click → yellow
     *  (selected) is visible. Used by the AI assistant's manual preserve
     *  workflow; not a real load-case step. */
    PRESERVES
}

export enum PartType {
    DESIGN,
    NONDESIGN,
    NONE
}

export enum PartSubType {
    BOUNDARY_CONDITION,
    LOAD,
    BASE,
    NONE
}

export enum ActionType {
    LIST,
    ADD,
    EDIT
}

export enum LoadCaseType {
    STATIC,
    THERMO_MECHANICAL,
    VIBRATION,
    HARMONIC_EXCITATION,
    RANDOM_VIBRATION,
    HARMONIC_EXCITATION_BASE,
    RANDOM_VIBRATION_BASE
}

export enum LoadType {
    FORCE,
    PRESSURE,
    ACCELERATION
}

export enum ManufacturingMethod {
    AdditiveManufacturing = "Additive Manufacturing",
    Milling = "Milling",
    Milling2 = "Milling2",
    InjectionMoldingWithDrawDirection = "Injection Molding with draw direction",
    DieCasting = "Die Casting",
    Extrusion = "Extrusion",
    InjectionMoldingWithExtrusion = "Injection Molding with extrusion",
    InvestmentCasting = "InvestmentCasting",
}

export enum ExtrusionPlaneGenerationMode {
    Even = "Even",
    GenerateFromDesDomain = "GenerateFromDesDomain",
    GenerateFromInitGuess = "GenerateFromInitGuess",
}

export enum DesignObjective {
    MinimizeCompliance = "compliance-response",
    MinimizeWeightedCompliance = "weighted-compliance-response",
    MinimizeMass = "mass-response",
    MaximizationOfFundamentalFrequencies = "vibration-response",
    MinimumVolumeUnderFrequencyConstraint = "frequency",
    MinimizeMassRMS = "mass-rms-response",
    MinimizeStressRMS = "stress-rms-response"
}

export enum MaterialCategory {
    Metal = "Metal",
    Polymer = "Polymer",
    Composite = "Composite",
    Ceramic = "Ceramic",
    Alloy = "Alloy"
}

export enum MaterialType {
    Aluminum = "Aluminum",
    Steel = "Steel",
    Titanium = "Titanium",
    Polymer = "Polymer",
    Composite = "Composite",
    Nickel = "Nickel",
    Cobalt = "Cobalt",
    Copper = "Copper",
    Ceramic = "Ceramic",
}

export enum RunType {
    Standard = 0,
    FiniteElementAnalysis = 1
}

/**
 * Label for status 7 ("in progress") that reflects whether the run is a
 * normal optimization or an FEA-only analysis. "Running" for FEA,
 * "Optimizing" otherwise. Used across cabinet list, sharing, compare
 * tile, and desktop tray.
 */
export function inProgressLabel(runType?: number | null): string {
    return runType === RunType.FiniteElementAnalysis ? 'Running' : 'Optimizing';
}

export enum ProjectType {
    TopologyOptimization = "topology_optimization",
    SoftJaws = "soft_jaws",
    Mold = "mold"
}